import React, {Component} from 'react';
import {ButtonIcon, ButtonPrimary} from '@homeaway/react-buttons';
import {GOOGLE_COLOR__24} from '@homeaway/svg-defs';
import {SVGIcon} from '@homeaway/react-svg';
import Script from 'react-load-script';
import PropTypes from 'prop-types';
import ClientLogger from '../../util/clientLogger';
import authAccountTypes from '../../enums/AuthAccountTypes';
import umsSettings from '../../util/ums.settings';
import './GoogleAuthComponent.less';
import {TrackingContext} from '@homeaway/react-event-tracking';
import aamClient from '../../util/aamClient';

class GoogleAuthComponent extends Component {
    static get propTypes() {
        return {
            enableLoading: PropTypes.func,
            disableLoading: PropTypes.func
        };
    }

    static get defaultProps() {
        return {
            enableLoading: () => {},
            disableLoading: () => {}
        };
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.token) {
            this.signUpAttempt();
            this.register(this.props.token);
        }
    }

    loginSuccess = (json) => {
        this.context.trigger('login.success', {logintype: 'google', loginsource: 'lex', publicuuid: json.publicUuid});
        this.authSuccess(json);
    }

    loginFailure = () => {
        this.setState({loggedIn: false});
        this.context.trigger('login.failure', {logintype: 'google', loginsource: 'lex'});
    }

    loginAttempt = () => {
        this.context.trigger('login.attempt', {logintype: 'google', loginsource: 'lex'});
    }

    displayErrorMessage = (error, errorTitle) => {
        this.props.handleError(error, errorTitle);
    }

    authSuccess = (json) => {
        this.setState({loggedIn: true});
        this.props.setAuthJson(json);
        this.props.onClose();
    }

    signUpSuccess = (json) => {
        if (this.props.marketingOptOut !== null) {
            this.context.trigger('user.account.created', {
                logintype: 'google',
                loginsource: 'lex',
                newusertype: 'traveler',
                publicuuid: json.publicUuid,
                marketingoptout: this.props.marketingOptOut
            });
        } else {
            this.context.trigger('user.account.created', {
                logintype: 'google',
                loginsource: 'lex',
                newusertype: 'traveler',
                publicuuid: json.publicUuid
            });
        }
        // set logged in state and close modal
        this.authSuccess(json);
    }

    signUpFailure = (statusCode) => {
        this.setState({loggedIn: false});
        if (this.props.marketingOptOut !== null) {
            this.context.trigger('user.account.creation.failure', {
                logintype: 'google',
                loginsource: 'lex',
                failurereason: `${statusCode}`,
                marketingoptout: this.props.marketingOptOut,
                newusertype: 'traveler'
            });
        } else {
            this.context.trigger('user.account.creation.failure', {
                logintype: 'google',
                loginsource: 'lex',
                failurereason: `${statusCode}`,
                newusertype: 'traveler'
            });
        }
    }

    signUpAttempt() {
        if (this.props.marketingOptOut !== null) {
            this.context.trigger('user.account.creation.attempt', {
                logintype: 'google',
                loginsource: 'lex',
                marketingoptout: this.props.marketingOptOut,
                newusertype: 'traveler'
            });
        } else {
            this.context.trigger('user.account.creation.attempt', {
                logintype: 'google',
                loginsource: 'lex',
                newusertype: 'traveler'
            });
        }
    }

    googleGenericEdap = (message) => {
        this.context.trigger('generic.event', {eventaction: `lexGoogleAuth.${message}`, eventcategory: 'lexGoogleAuth'});
    }

    handleJson(json, user) {
        if (json) {
            if (authAccountTypes.isNotUndefined(json.authType)) {
                let SIGNUP = this.checkAuthType(json.authType, authAccountTypes.SIGNUP);
                if (SIGNUP && umsSettings.isTCRequired(this.props.site)) {
                    let emailAddress = user.getBasicProfile().getEmail();
                    // this is the SignUp scenario, so we need to update the pageName to TermsAndConditions only for the required EU brands
                    let pageName = 'TermsAndConditions';
                    this.props.performBulkPageUpdate(pageName, emailAddress, authAccountTypes.GOOGLE, user);
                    this.props.disableLoading();
                } else {
                    let umsOnly = this.checkAuthType(json.authType, authAccountTypes.UMS);
                    if (SIGNUP || umsOnly) {
                        this.signUpAttempt();
                        this.register(user);
                    } else {
                        this.loginAttempt();
                        this.authenticate(user);
                    }
                }
            }
        }
    }

    checkAuthType(accountType, loginType) {
        return accountType.some((t) => (t === loginType));
    }

    googleAuthStatus(user) {
        const payload = {
            accessToken: user.getAuthResponse().id_token,
            authType: 'GOOGLE'
        };

        return new Promise((resolve, reject) => {
            aamClient.tokenStatus(payload).then((response) => {
                if (response.status >= 200 && response.status < 400) {
                    response.json().then((json) => {
                        this.handleJson(json, user);
                        return resolve();
                    });
                }
            }).catch((e) => {
                // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                    this.displayErrorMessage(this.props.lingua.read('error.generic'), '');
                }
                return reject(e);
            });
        });
    }

    authenticate(user) {
        let emailAddress = user.getBasicProfile().getEmail();
        const payload = {
            'userName': emailAddress,
            'authType': 'GOOGLE',
            'secret': user.getAuthResponse().id_token,
            'rememberMe': true
        };

        return new Promise((resolve, reject) => {
            aamClient.authenticate(payload).then((response) => {
                this.checkStatus(response, resolve, reject, false);
                return resolve();
            }).catch((e) => {
                return this.failLogin(e, reject, false);
            });
        });
    }

    register(user) {
        let emailAddress = user.getBasicProfile().getEmail();
        let token = user.getAuthResponse().id_token;
        const payload = {
            userName: emailAddress,
            secret: token,
            authType: 'GOOGLE',
            rememberMe: true
        };

        return new Promise((resolve, reject) => {
            aamClient.register(payload).then((response) => {
                this.checkStatus(response, resolve, reject, true);
                return resolve();
            }).catch((e) => {
                return this.failLogin(e, reject, true);
            });
        });
    }

    checkStatus(response, resolve, reject, isRegister) {
        if (response.status >= 200 && response.status < 400) {
            response.json().then((json) => {
                if (isRegister === true) {
                    this.signUpSuccess(json);
                } else {
                    this.loginSuccess(json);
                }
            });
            return resolve();
        }
        this.props.disableLoading();
        if (isRegister === true) {
            this.signUpFailure(response.status);
        } else {
            this.loginFailure();
        }
        this.displayErrorMessage(this.props.lingua.read('error.generic'), '');
        return reject();
    }

    failLogin(e, reject, isRegister) {
        this.props.disableLoading();
        if (isRegister === true) {
            this.signUpFailure(e);
        } else {
            this.loginFailure();
        }
        this.displayErrorMessage(this.props.lingua.read('error.generic'), '');
        return reject(e);
    }

    displayGoogleLabel() {
        if (this.props.expediaIconDisplayed === true) {
            return (
                <div className="Google_Label">
                    <label>{this.props.lingua.read('lex.google.icon.label')}</label>
                </div>
            );
        }
        return (
            <div/>
        );
    }

    displayAppropriateButton() {
        if (typeof this.props.authStatus !== 'undefined') {
            return (
                <div className="SocialButtons__icon">
                    <ButtonPrimary label="" className="btn--google btn-block" onClick={this.onClickGoogle} name={this.props.name} id={this.props.id}>
                        <SVGIcon className="btn--spacing" inlineFlex markup={GOOGLE_COLOR__24} />
                        <span>{this.props.lingua.read('lex.social.login.with.card.message.google')}</span>
                    </ButtonPrimary>
                </div>
            );
        }
        return (
            <div className="small">
                <ButtonIcon circle svgMarkup={GOOGLE_COLOR__24} onClick={this.onClickGoogle} label="Google" name={this.props.name} id={this.props.id}/>
                {this.displayGoogleLabel()}
            </div>
        );
    }


    onClickGoogle = () => {
        this.googleGenericEdap('googleButtonClicked');
        let auth;
        if (window.gapi) {
            try {
                auth = window.gapi.auth2.getAuthInstance();
            } catch (error) {
                ClientLogger.logError(`An error has occurred while getting auth instance: ${error}`);
            }
            if (!auth) {
                return new Promise((resolve, reject) => {
                    reject('no auth');
                });
            }
            /* If the user is signed in, attempt to
             register them, otherwise sign in */
            if (auth.isSignedIn.get()) {
                return auth.signIn().then((user) => {
                    this.props.enableLoading();
                    return this.googleAuthStatus(user);
                }).catch((e) => {
                    // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                    if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                        this.displayErrorMessage(this.props.lingua.read('error.generic'), '');
                    }
                });
            }
            let errorMsg = this.props.lingua.read('lex.social.browser.error');
            let errorTitle = this.props.lingua.read('lex.social.browser.error.title');
            let timer = null;
            let signUp = auth.signIn().then((user) => {
                clearTimeout(timer);
                this.props.enableLoading();
                return this.googleAuthStatus(user);
            }).catch((e) => {
                // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                let error;
                if (typeof e === 'undefined') {
                    error = 'googleUserError';
                    this.googleGenericEdap(error);
                } else {
                    error = e.error;
                    this.googleGenericEdap(error);
                }
                if (error !== 'popup_closed_by_user') {
                    this.displayErrorMessage(this.props.lingua.read('error.generic'), '');
                }
            });
            // Due to known Google issue, 3rd part cookies disabled/ad blocker will cause sign up promise to never return, so we do a race
            return Promise.race([
                new Promise((resolve, reject) => {
                    timer = setTimeout(() => {
                        this.googleGenericEdap('adBlockerError');
                        this.displayErrorMessage(errorMsg, errorTitle);
                        reject('invalid browser settings');
                    }, 30000);
                    return timer;
                }),
                signUp
            ]);
        }
        this.props.disableLoading();
        return new Promise((resolve, reject) => {
            this.googleGenericEdap('noGApiError');
            this.displayErrorMessage(this.props.lingua.read('error.generic'), '');
            reject('no gapi');
        });
    }

    handleScriptError = () => {
        this.context.trigger('generic.event', {eventaction: 'lexGoogleAuth.googleScriptError', eventcategory: 'lexGoogleAuth'});
    }

    handleScriptLoad = () => {
        /* istanbul ignore next */
        window.gapi.load('auth2', () => {
            window.gapi.auth2.init({
                client_id: '42464624060-9dvu968n052patjorlqk96iq0ucbmrjs.apps.googleusercontent.com'
            }).then(() => {
                this.context.trigger('generic.event', {eventaction: 'lexGoogleAuth.googleScriptLoad', eventcategory: 'lexGoogleAuth'});
            }, (error) => {
                ClientLogger.logError(`An error has occurred while initializing google script: ${error.details}`);
            });
        }, (error) => {
            ClientLogger.logError(`An error has occurred while loading google script: ${error}`);
        });
    }

    render() {
        return (
            <div>
                <Script
                    url="https://apis.google.com/js/api.js"
                    onError={this.handleScriptError}
                    onLoad={this.handleScriptLoad}
                />
                {this.displayAppropriateButton()}
            </div>

        );
    }
}

GoogleAuthComponent.contextType = TrackingContext;
export default GoogleAuthComponent;
